import React from 'react';
const PluginIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "currentColor",
  d: "M2 2h14v2H2V2zm0 4h10v2H2V6zm0 4h14v2H2v-2zm0 4h10v2H2v-2z"
}));
export default PluginIcon;